// extracted by mini-css-extract-plugin
export var carrierNotice = "_lq-5";
export var carrierNoticePlaceholder = "_lq-6";
export var deliveryRow = "_lq-c";
export var fixedHeight = "_lq-4";
export var freightLogo = "_lq-b";
export var fullWidth = "_lq-3";
export var priceColumn = "_lq-7";
export var radioSelected = "_lq-9";
export var radioUnselected = "_lq-8";
export var selectedOption = "_lq-2";
export var selectedOptionContainer = "_lq-1";
export var selection = "_lq-0";
export var tallSkeletonText = "_lq-a";